import React from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'

import css from './Menu.module.scss'
import Logo from '../../../../assets/logo.svg'

import { menuConstants } from '../../../../constants'
import MenuItem from './MenuItem/MenuItem'

const Menu = () => {
  const { pathname } = useLocation()

  return (
    <div className={css.MenuContainer}>
      <div className={css.Menu}>
        <div className={css.Top}>
          <img src={Logo} alt='BukZone' className={css.Logo} />
          {pathname !== '/organizations' &&
            pathname !== '/organizations/_new' &&
            pathname !== '/settings' && (
              <ul className={css.UlMenu}>
                {menuConstants.leftMenu
                  .filter((x) => x.location === 'top')
                  .map((item, index) => (
                    <li key={index}>
                      <MenuItem item={item} />
                    </li>
                  ))}
              </ul>
            )}
        </div>
        <ul className={css.UlMenu}>
          {menuConstants.leftMenu
            .filter((x) => x.location === 'bottom')
            .map((item, index) => (
              <li key={index}>
                <MenuItem item={item} />
              </li>
            ))}
        </ul>
      </div>
    </div>
  )
}

export default Menu
